<template>
    <BaseForm v-if="series">
        <template #fields>
            <MultiLink
                :label="$t('other-documents')"
                :links="values.otherLinks"
                :error-messages="errors.otherLinks"
                @input="setFieldValue('otherLinks', $event)"
                @delete="setFieldValue('otherLinks', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesOtherLinksSchema } from '@/project/schemas';
import { computed } from 'vue';

defineProps<{ seriesId: string }>();

const { series, createProjectSeriesMultiLink } = useProjectSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectSeriesMultiLink);

const otherLinksId = computed(() => series.value?.otherLinks?.id);
const otherLinksLinks = computed(
    () =>
        series.value?.otherLinks?.links.nodes.map((n) => ({
            ...n,
            multilinkId: otherLinksId.value,
            status: 'skip' as const,
        })) ?? [],
);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesOtherLinksSchema,
    computed(() => ({
        otherLinks: getFormFieldLinks(otherLinksLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            {
                id: otherLinksId.value,
                fieldName: 'otherLinks',
                links: values.value.otherLinks,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
